const DEFAULT_LANGUAGE = 'en';

const SCRIPT_ID = 'ReduniqScript';

const SCRIPT_URL = `${process.env.PROVIDER_REDUNIQ_URL}/gateway/assets/widget/iframe/v1/index.min.js`;

const SUPPORTED_LANGUAGES = ['de', 'en', 'es', 'fr', 'pt'];

export { DEFAULT_LANGUAGE, SCRIPT_ID, SCRIPT_URL, SUPPORTED_LANGUAGES };
